export default function ($rootScope, $state, $anchorScroll, visitedPagesService) {
  'ngInject';
  $rootScope.$on('$locationChangeSuccess', function ($event, next, current) {
    $anchorScroll();

    if( next !== current) visitedPagesService.addPageToCounter();
  });
}



// WEBPACK FOOTER //
// ./client/app/app.run.js